import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, LinearProgress, Tab, Tabs, Typography } from '@mui/material';

import { LayoutBase } from '../../../../../layouts';
import { VMenu } from '../../../../../components/shared';
import { ToolsDamInformation, GeralINformation, TechnicalCharacteristics, OperationalCharacteristics, GeographicLocation } from '../../../../../components/custom';
import { IDam, DamsServices } from '../../../../../services/api/dams/DamServices';
import { Edit } from '@mui/icons-material';
import { useAuthContext } from '../../../../../context';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const FeaturesUndertaking = () => {

  const [value, setValue] = React.useState(0);
  const url = useParams();
  const navigate = useNavigate();
  const { userData } = useAuthContext();

  const [data, setData] = useState<IDam>();

  const fetchData = () => {
    if (url && url.id) {
      DamsServices.getById(url.id)
        .then((result) => {
          if (result instanceof Error) {
            alert(result.message);
          } else {
            setData(result);
          }
        });
    }
  };

  useEffect(() => {
    fetchData();
  }, [url]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <LayoutBase title='Informações da barragem'
      tollBar={
        <ToolsDamInformation />
      }
    >
      <Box width={'100%'}>
        <VMenu id={url.id} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab label="Informações Gerais" {...a11yProps(0)} />
            <Tab label="CARACTERÍSTICAS TÉCNICAS/OPERACIONAIS" {...a11yProps(1)} />
            <Tab label="CARACTERÍSTICAS OPERACIONAIS" {...a11yProps(2)} />
            <Tab label="LOCALIZAÇÃO GEOGRÁFICA" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <Box padding={2} display={'flex'} justifyContent={'end'} marginBottom={-5}>
          {userData.nivel == 'adm' || userData.nivel == 'empresa' ? <>
            <Button startIcon={<Edit />} variant='contained' onClick={() => navigate(`/company_dam/${userData.id_empresa}/detalhes/${url.id}`)} sx={{ borderRadius: '25px' }}>Editar</Button>
          </> : null}
        </Box>
        <CustomTabPanel value={value} index={0}>
          {data ?
            <GeralINformation data={data} />
            :
            <LinearProgress />
          }
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {data ?
            <TechnicalCharacteristics data={data} />
            :
            <LinearProgress />
          }
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {data ?
            <OperationalCharacteristics data={data} />
            :
            <LinearProgress />
          }
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {data ?
            <GeographicLocation data={data} />
            :
            <LinearProgress />
          }
        </CustomTabPanel>
      </Box>
    </LayoutBase>
  );
};


